import { useEffect, useRef, useState } from "react";
import { LuTableOfContents } from "react-icons/lu";
import "./nav.css";

function Nav({ advancedmode }) {
	const [nestedHeadings, setNestedHeadings] = useState([]);
	const [activeId, setActiveId] = useState();
	const visibleHeadingsRef = useRef([]);

	const scrollTo = (e, id) => {
		e.stopPropagation();
		document.querySelector("#" + id).scrollIntoView({ behavior: "smooth" });
	}

	const Headings = () => (
		<ul>
			{
				nestedHeadings.map((heading) => {
					const regex = /Domain\s[1-9]/gm;
					if (heading.title.match(regex)) {
						heading.title = heading.title.slice(0, heading.title.indexOf("Domain"))
					}
					return (
						<li
							className={heading.id === activeId ? "active" : ""}
							key={"toc-heading-" + heading.id}
							onClick={(event) => scrollTo(event, heading.id)}
						>
							{heading.title}
							{heading.id === activeId &&
								<div className="active accent" />
							}
						</li>
					)
				})
			}
		</ul>
	);

	useEffect(() => {
		const nestedHeadings = [];

		// timout to wait for conditionally rendered headings to render
		setTimeout(() => {
			Array.from(document.querySelectorAll("h1, h2")).forEach((heading) => {
				const { innerText: title, id } = heading;
				nestedHeadings.push({ id, title, subheadings: [] });
			});
			setNestedHeadings(nestedHeadings);
		}, 100);
	}, [advancedmode])

	useEffect(() => {
		const observer = new IntersectionObserver((headings) => {
			headings.forEach((heading) => {
				if (heading.isIntersecting) {
					visibleHeadingsRef.current.push(heading);
				} else {
					// if present remove from ref
					if (visibleHeadingsRef.current.findIndex((h) => h.target.id === heading.target.id) >= 0) {
						visibleHeadingsRef.current.splice(visibleHeadingsRef.current
							.findIndex((h) => h.target.id === heading.target.id), 1);
					}
				}
			});

			if (visibleHeadingsRef.current.length > 0) {
				visibleHeadingsRef.current = visibleHeadingsRef.current
					.sort((a, b) => a.target.offsetTop - b.target.offsetTop);
				const activeHeading = visibleHeadingsRef.current[0];
				setActiveId(activeHeading.target.id);
			}
		}, {
			root: null,
			rootMargin: "-10% 0px -50% 0px",
			threshold: 0.1,
		})

		// timout to wait for conditionally rendered headings to render
		setTimeout(() => {
			Array.from(document.querySelectorAll("h1, h2")).forEach((heading) => {
				observer.observe(heading);
			})
		}, 100);
	}, []);

	return (
		<nav className="toc">
			<h4><LuTableOfContents className="toc-icon" />On this Page</h4>
			<Headings />
		</nav>
	)
}

export default Nav;
